import {Box, FormHelperText, SxProps, Theme} from "@mui/material";

import {designColors, designTokens} from "~/ui";

export interface BmHelperTextProps {
  className?: string;
  sx?: SxProps<Theme>;
  error?: boolean;
  dangerouslySetInnerHTML?:
    | {
        __html: string;
      }
    | undefined;
  children?: React.ReactNode | undefined;
}

export const BmHelperText: React.FC<BmHelperTextProps> = ({
  className,
  sx,
  error = false,
  dangerouslySetInnerHTML,
  children,
}) => {
  return (
    <Box
      component={FormHelperText}
      className={className}
      sx={{
        fontSize: designTokens.fontSize.xs,
        fontWeight: designTokens.fontWeight.regular,
        lineHeight: designTokens.lineHeight.tight,
        color: error ? designColors.error : designColors.grey_5,
        ...sx,
      }}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    >
      {children}
    </Box>
  );
};
